"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _createEntryCards = _interopRequireDefault(require("./create-entry-cards"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("td", null, "Entry Limit");
var _ref2 = /*#__PURE__*/_react.default.createElement("td", null, "Places Reserved");
var _ref3 = /*#__PURE__*/_react.default.createElement("td", null, "Entries Accepted (that trigger limit)");
var _ref4 = /*#__PURE__*/_react.default.createElement("td", null, "Places Offered To Waiting List Entries");
var _ref5 = /*#__PURE__*/_react.default.createElement("th", null, "Places Available");
var _ref6 = /*#__PURE__*/_react.default.createElement("h4", null, "Entries By Race");
var _ref7 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: 2,
  className: "text-xs-center"
}, "Accepted"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: 2,
  className: "text-xs-center"
}, "Wait List")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Race"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Host"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Other"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Host"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Other")));
var _ref8 = /*#__PURE__*/_react.default.createElement("th", null, "Total");
var _ref9 = /*#__PURE__*/_react.default.createElement("h4", null, "All Entries By Status");
var _ref10 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: 2,
  className: "text-xs-center"
}, "Triggering Limit?"), /*#__PURE__*/_react.default.createElement("th", {
  colSpan: 2,
  className: "text-xs-center"
}, "Source")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Status"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Yes"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "No"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Online"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Post")));
class DaySummary extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onChange", (id, field, value) => {
      this.props.onUpdateCompetitionDay(id, field, value);
    });
  }
  render() {
    const day = this.props.day;

    // set up an array for all valid statusRefs
    const entrySummary = {};
    entrySummary.Total = {
      included: 0,
      excluded: 0,
      online: 0,
      postal: 0
    };
    for (const status of this.props.entryStatusRefs) {
      if (!entrySummary[status.refCode]) {
        entrySummary[status.refCode] = {
          included: 0,
          excluded: 0,
          online: 0,
          postal: 0
        };
      }
    }
    const racesSummary = {};
    racesSummary.Total = {
      COMPhost: 0,
      COMPother: 0,
      WAIThost: 0,
      WAITother: 0
    };
    const offeredPlace = {
      included: 0,
      excluded: 0
    };

    // populate with counts, ignore any invalid rows
    for (const entry of day.entries) {
      if (entrySummary[entry.entryStatusRef]) {
        entrySummary[entry.entryStatusRef][entry.competitionDivision.isIncludedInEntryLimits ? 'included' : 'excluded'] += 1;
        entrySummary[entry.entryStatusRef][entry.isOnlineEntry ? 'online' : 'postal'] += 1;
      }
      if (entry.entryStatusRef === 'WAIT' && entry.canEnterFromWaitingList) {
        offeredPlace[entry.competitionDivision.isIncludedInEntryLimits ? 'included' : 'excluded'] += 1;
      }
      if (entry.entryStatusRef === 'COMP' || entry.entryStatusRef === 'WAIT') {
        if (!racesSummary[entry.raceID]) {
          racesSummary[entry.raceID] = {};
        }
        const column = entry.entryStatusRef + (entry.entryTypeID === 'HOST' ? 'host' : 'other');
        racesSummary[entry.raceID][column] = (racesSummary[entry.raceID][column] || 0) + 1;
        racesSummary.Total[column] += 1;
      }
    }
    const placesStillAvailable = day.entryLimit - day.reservedEntry - entrySummary.COMP.included - offeredPlace.included;
    return /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 12,
      lg: 6
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-header"
    }, /*#__PURE__*/_react.default.createElement("h3", null, (0, _occasion.default)(day.dayDate, 'dddd'))), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "lead"
    }, day.isFull ? 'Day is marked as full' : ''), /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, _ref, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "entryLimit",
      value: day.entryLimit,
      onChange: this._onChange.bind(this, day.id, 'entryLimit'),
      maxlength: 4,
      required: true
    }))), /*#__PURE__*/_react.default.createElement("tr", null, _ref2, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "reservedEntry",
      value: day.reservedEntry,
      onChange: this._onChange.bind(this, day.id, 'reservedEntry'),
      maxlength: 4,
      required: true
    }))), /*#__PURE__*/_react.default.createElement("tr", null, _ref3, /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only text-xs-right"
    }, entrySummary.COMP.included)), /*#__PURE__*/_react.default.createElement("tr", null, _ref4, /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only text-xs-right"
    }, offeredPlace.included)), /*#__PURE__*/_react.default.createElement("tr", {
      className: placesStillAvailable > 0 ? placesStillAvailable < 10 ? 'table-warning' : 'table-success' : placesStillAvailable < 0 ? 'table-danger' : ''
    }, _ref5, /*#__PURE__*/_react.default.createElement("th", {
      className: "read-only text-xs-right"
    }, placesStillAvailable)))), !entrySummary.COMP.excluded ? null : /*#__PURE__*/_react.default.createElement("p", null, "You have also accepted ", entrySummary.COMP.excluded, entrySummary.COMP.excluded > 1 ? ' entries that do not trigger the limit' : ' entry that does not trigger the limit', !offeredPlace.excluded ? '' : ' and offered ' + offeredPlace.excluded + (offeredPlace.excluded > 1 ? ' further places' : ' further place'), ".")), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block",
      style: {
        borderTop: '1px solid rgba(0,0,0,0.125)'
      }
    }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 12,
      xl: 6
    }, _ref6, /*#__PURE__*/_react.default.createElement(_table.default, null, _ref7, /*#__PURE__*/_react.default.createElement("tbody", null, day.races.filter(r => racesSummary[r.id]).map(race => /*#__PURE__*/_react.default.createElement("tr", {
      key: race.id
    }, /*#__PURE__*/_react.default.createElement("td", null, race.raceName), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only text-xs-right"
    }, racesSummary[race.id].COMPhost || 0), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only text-xs-right"
    }, racesSummary[race.id].COMPother || 0), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only text-xs-right"
    }, racesSummary[race.id].WAIThost || 0), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only text-xs-right"
    }, racesSummary[race.id].WAITother || 0)))), /*#__PURE__*/_react.default.createElement("tfoot", null, /*#__PURE__*/_react.default.createElement("tr", null, _ref8, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, racesSummary.Total.COMPhost || 0), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, racesSummary.Total.COMPother || 0), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, racesSummary.Total.WAIThost || 0), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, racesSummary.Total.WAITother || 0))))), /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 12,
      xl: 6
    }, _ref9, /*#__PURE__*/_react.default.createElement(_table.default, null, _ref10, /*#__PURE__*/_react.default.createElement("tbody", null, this.props.entryStatusRefs.map(status => /*#__PURE__*/_react.default.createElement("tr", {
      key: status.refCode
    }, /*#__PURE__*/_react.default.createElement("td", null, status.description), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only text-xs-right"
    }, entrySummary[status.refCode].included), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only text-xs-right"
    }, entrySummary[status.refCode].excluded), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only text-xs-right"
    }, entrySummary[status.refCode].online), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only text-xs-right"
    }, entrySummary[status.refCode].postal)))))), /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_createEntryCards.default, {
      competitionSlug: this.props.competitionSlug,
      yearID: this.props.yearID,
      competitionDay: day
    }))))));
  }

  //*******************************************************************************
  // partialQueries
  // *******************************************************************************
}

//*******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(DaySummary, "partialQueries", {
  CompetitionDay: _mergeBqlQueries({
    id: true,
    dayDate: true,
    entryLimit: true,
    reservedEntry: true,
    isFull: true,
    entries: {
      entryStatusRef: true,
      competitionDivision: {
        isIncludedInEntryLimits: true
      },
      raceID: true,
      isOnlineEntry: true,
      entryTypeID: true,
      canEnterFromWaitingList: true
    },
    races: {
      id: true,
      raceName: true,
      competitionDivision: {
        description: true,
        isRanking: true
      },
      eventDescription: true
    }
  }, _createEntryCards.default.partialQueries.CompetitionDay),
  EntryStatusRefs: {
    refCode: true,
    description: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(DaySummary, undefined, (client, props) => ({
  onUpdateCompetitionDay(id, field, value) {
    return client.update('CompetitionDay.set', {
      id,
      field,
      value
    });
  }
}));